module.exports = __webpack_public_path__ + "img/press-media.a4eb1bf6.jpg";